export default __webpack_public_path__ + "static/media/cv.1a4c88f2.pdf";